import {GetterTree} from "vuex";
import {ReportsState} from "@/store/reports/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<ReportsState, RootState> = {
  reports:state => state.reports ?? [],
  reportStatusList:state => state.reportStatusList,
  reportTypeList:state => state.reportTypeList,
  summaryGroup:state => state.summaryGroup ?? [],
}